import { render, staticRenderFns } from "./public-header2.vue?vue&type=template&id=2ecd4473&scoped=true&"
import script from "./public-header2.vue?vue&type=script&lang=js&"
export * from "./public-header2.vue?vue&type=script&lang=js&"
import style0 from "./public-header2.vue?vue&type=style&index=0&id=2ecd4473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd4473",
  null
  
)

export default component.exports